export const FIXED = '';
export const PER_PERSON = 'per_person';
export const ITEM_QUANTITY = 'standard';
